import { Box } from '@mui/material';
import TestimonialPagesContainer from '../../components/testimonial-pages/TestimonialPagesContainer';

const TestimonialPagesPage = () => {
  return (
    <Box>
      <TestimonialPagesContainer />
    </Box>
  )
}

export default TestimonialPagesPage;
